import { createRouter, createWebHistory } from 'vue-router'
import { useToken } from '@/composables/useToken'
import { saveRedirectUrl } from '@app-common'

export const AuthRoutesNames = {
  login: 'login',
  logout: 'logout',
  resetPassword: 'reset-password',
  register: 'register',
  registerConfirm: 'register-confirm',
  authView: 'authView',
  redirect: 'redirect',
  userAgreement: 'user-agreement',
  privacyPolicy: 'privacy-policy',
}
const BASE_PATH = '/identity'

const router = createRouter({
  history: createWebHistory(BASE_PATH),
  routes: [
    {
      path: '/',
      name: AuthRoutesNames.authView,
      redirect: { name: AuthRoutesNames.login },
      children: [
        {
          path: 'login',
          name: AuthRoutesNames.login,
          component: () => import('@/views/LoginView.vue'),
        },
        {
          path: 'register',
          name: AuthRoutesNames.register,
          component: () => import('@/views/RegisterView.vue'),
        },
        {
          path: 'register-confirm',
          name: AuthRoutesNames.registerConfirm,
          component: () => import('@/views/RegisterConfirmView.vue'),
        },
        {
          path: 'reset-password',
          name: AuthRoutesNames.resetPassword,
          component: () => import('@/views/ResetPasswordView.vue'),
        },
        {
          path: 'redirect',
          name: AuthRoutesNames.redirect,
          component: () => import('@/views/RedirectAfterLogin.vue'),
        },
        {
          path: 'user-agreement',
          name: AuthRoutesNames.userAgreement,
          component: () => import('@/views/UserAgreementView.vue'),
        },
        {
          path: 'privacy-policy',
          name: AuthRoutesNames.privacyPolicy,
          component: () => import('@/views/PrivacyPolicyView.vue'),
        },
        {
          path: 'logout',
          name: AuthRoutesNames.logout,
          component: () => import('@/views/LogoutView.vue'),
        },
      ],
    },
  ],
})

router.beforeEach((to, _from, next) => {
  if (to.meta.requiresAuth) {
    const { getToken } = useToken()

    if (!getToken()) {
      const urlWithDomain = `${window.location.origin}${BASE_PATH}${to.fullPath}`
      saveRedirectUrl(urlWithDomain, import.meta.env.DEV)
      next({ name: AuthRoutesNames.login })
      return
    }
  }

  next()
})

export default router
